import * as React from 'react';
import { cn } from '@/lib/utils/cn';

const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type = 'text', ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      'flex h-11 w-full rounded-lg border border-border bg-white px-4 py-2 text-sm text-ink shadow-sm transition-colors',
      'placeholder:text-muted',
      'focus-visible:border-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/30',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive/30',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
